import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
// --------
import { setMenuSelected } from '@redux/actions/menuAction';
import Clearfix from 'components/elements/clearfix';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { DATE_FORMAT } from 'config';
import slug from 'constants/slug';
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

class FacilityEiaPanel extends React.Component {
  static propTypes = {
    facilityId: PropTypes.string.isRequired,
    hideRightHeaderContent: PropTypes.bool,
    dataList: PropTypes.array,
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <FacilityEiaList
          hideRightHeaderContent
          facilityId={this.props.facilityId}
          dataList={this.props.dataList}
        />
      </div>
    );
  }
}

class FacilityEiaList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {};
    const columns = [
      {
        dataField: 'Title',
        text: 'Tên hồ sơ',
        formatter: (cell, row) => {
          return (
            <Link target='_blank' to={slug.FACILITY_EIA.VIEW_WITH_ID + row._id}>
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      {
        dataField: 'DecisionNumber',
        text: 'Số quyết định',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'DateIssued',
        text: 'Ngày phát hành',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },

      {
        dataField: 'IssuingAgency',
        text: 'Cơ quan cấp',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'EIAURL',
        text: 'Đường dẫn (URL)',
        formatter: (cell, row) => {
          if (!cell) {
            return null;
          }
          return (
            <a href={cell} target='_blank'>
              <NameContainer>{cell}</NameContainer>
            </a>
          );
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_EIA.CREATE}?facilityId=${props.facilityId}`,
      'facilityeia',
      null,
      false
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
      dataList: this.props.dataList,
      isLoading: false,
    };
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacilityEiaPanel)
);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/FacilityeiaPanel/index.js